import React from 'react';
import { Tracking } from '../../services/api';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import { P2GTranslation } from '@parcel2go/peacock-legacy-resources/dist/translations';
import { useP2GProfile } from '@parcel2go/peacock-legacy-profile/dist/contextProvider';
import { useP2GMediaQueryDown } from '@parcel2go/peacock-legacy-core';
import { CourierLogo } from '../courierLogo';

interface IOrderHeaderProps {
  tracking: Tracking,
  onValidate: (value: string) => void,
  authenticated: boolean,
  signIn: () => void,
  openValidation: boolean,
  onCloseValidation: () => void,
  onOpenValidation: () => void
}

const OrderHeader: React.FC<IOrderHeaderProps> = (props) => {
  const isBreak = useP2GMediaQueryDown('xs');
  const profile = useP2GProfile();
  const tracking = props.tracking;
  const order = tracking.order;

  return (
    <>
      <P2GGrid container direction="column">
        <P2GGrid item>
          <P2GGrid container direction={!isBreak ? "row" : "column"} justify="space-between" alignItems="center" spacing={1}>
            <P2GGrid item>
              <CourierLogo tracking={tracking}/>
            </P2GGrid>
            <P2GGrid item>
            <P2GText variant='subtitle1'><P2GTranslation translation=''>Order Number:</P2GTranslation> </P2GText>
              {profile.settings && profile.settings.prefix &&
                <P2GText variant="subtitle1">{profile.settings.prefix}</P2GText>
              }
              {(!profile.settings || !profile.settings.prefix) &&
                <React.Fragment>
                  <P2GText colour="secondary" variant="subtitle1"><P2GTranslation translation="TRACKING.RESULT.ORDER.ORDERLINEID" /></P2GText>
                            &nbsp;
                        </React.Fragment>
              }
              <P2GText variant="subtitle1">{order.orderLineId}</P2GText>
            </P2GGrid>
          </P2GGrid>

        </P2GGrid>
      </P2GGrid>
      <br />
    </>
  );
}

export default OrderHeader;